import { z } from 'zod';
import { getPhotoSchema, photoOptionalSchema } from '../../../constants/sharedSchemas';

export const familyPhotosSchema = {
  required: z.object({
    homeExterior: z.object({
      photo: getPhotoSchema('Home Exterior and Grounds photo'),
      description: z.string().min(1, 'Description is required'),
    }),
    livingRoom: z.object({
      photo: getPhotoSchema('Family or Living Room photo'),
      description: z.string().min(1, 'Description is required'),
    }),
    kitchen: z.object({
      photo: getPhotoSchema('Kitchen photo'),
      description: z.string().min(1, 'Description is required'),
    }),
    studentBedroom: z.object({
      photo: getPhotoSchema("Student's Bedroom photo"),
      description: z.string().min(1, 'Description is required'),
    }),
    studentBathroom: z.object({
      photo: getPhotoSchema("Student's Bathroom photo"),
      description: z.string().min(1, 'Description is required'),
    }),
    additionalPhotos: z.array(
      z.object({
        title: z.string().min(1, 'Photo title is required'),
        photo: getPhotoSchema('Photo'),
        description: z.string().min(1, 'Photo description is required'),
      }),
    ),
  }),
  optional: z.object({
    homeExterior: z.object({
      photo: photoOptionalSchema,
      description: z.string().optional(),
    }),
    livingRoom: z.object({
      photo: photoOptionalSchema,
      description: z.string().optional(),
    }),
    kitchen: z.object({
      photo: photoOptionalSchema,
      description: z.string().optional(),
    }),
    studentBedroom: z.object({
      photo: photoOptionalSchema,
      description: z.string().optional(),
    }),
    studentBathroom: z.object({
      photo: photoOptionalSchema,
      description: z.string().optional(),
    }),
    additionalPhotos: z.array(
      z.object({
        title: z.string().optional(),
        photo: photoOptionalSchema,
        description: z.string().optional(),
      }),
    ),
  }),
};
export type FamilyPhotosFormValues = z.infer<(typeof familyPhotosSchema)['required']> | z.infer<(typeof familyPhotosSchema)['optional']>;
type AdditionalPhoto = FamilyPhotosFormValues['additionalPhotos'][number];

export const additionalPhotoDefaultValues: AdditionalPhoto = { photo: { id: '' }, description: '', title: '' };

export const defaultValues: FamilyPhotosFormValues = {
  homeExterior: { photo: { id: '' }, description: '' },
  livingRoom: { photo: { id: '' }, description: '' },
  kitchen: { photo: { id: '' }, description: '' },
  studentBedroom: { photo: { id: '' }, description: '' },
  studentBathroom: { photo: { id: '' }, description: '' },
  additionalPhotos: [],
};
